import React from "react";
import RegisterSendContact from "./Register_send_Mobile";
import RegisterGetCode from "./Register_Get_OTP";
import { connect } from "react-redux";
import Store from "../../redux/Store";
import {
  authUnauthorizedMessage,
  setCaptchaCode,
  setRegisterOTP,
} from "../../redux/Login/LoginActionCreators";
import { useHistory } from "react-router-dom";

const Register = ({ register_OTP }) => {
  React.useEffect(() => {
    Store.dispatch(setRegisterOTP(null));
    Store.dispatch(setCaptchaCode(""));
    Store.dispatch(authUnauthorizedMessage(null));
  }, []);
  const history = useHistory();
  return (
    <>
      {register_OTP === null ? (
        <RegisterSendContact />
      ) : register_OTP === "get" ? (
        <RegisterGetCode />
      ) : (
        history.push("/register/stages")
      )}
    </>
  );
};
const mapStateToProps = (props) => {
  const { loginReducer } = props;
  const { register_OTP, captchaCode } = loginReducer;

  return { register_OTP, captchaCode };
};

export default connect(mapStateToProps)(Register);
